import React, { useEffect } from 'react';
import { Card, CardBody, Container, Row, Col, Button, Input } from "reactstrap";
import FeedLibraryTable from "./FeedLibraryTable";
import { useDispatch, useSelector } from 'react-redux';
import { setFeedModalType, toggleCreateFeedModal, toggleDeleteAllModal, toggleDuplicateAllModal, toggleFolderModal } from '../../../slices/modals/reducer';
import CreateFeedModal from './CreateFeedModal';
import AddFieldModal from './AddFieldModal';
import { getFeeds } from '../../../slices/feeds/thunk';
import { getFolderRootThunk, newFolder, setFolderHistory } from '../../../slices/folder/thunk';
import { createSelector } from 'reselect';
import { Navigate, useLocation, useParams } from 'react-router-dom';
import { setPreloader } from '../../../slices/layouts/reducer';
import { getFeedSuccess, resetFeedState, setFeedsFirstLoad, setFeedsHasMore, setFeedsLoading, setFeedsPage, setFeedsShowLoader, setQuery } from '../../../slices/feeds/reducer';
import { replace } from "redux-first-history";
import FolderModal from '../../Folder';
import DeleteAllModal from "./DeleteAllModal";
import DuplicateAllModal from "./DuplicateAllModal";
import { setFolderRootPath } from '../../../slices/folder/reducer';
import { setBreadcrumb, setFolderPath } from '../../../slices/auth/menu/reducer';
import checkPermission from '../../../Components/Hooks/PermissionHook';
import NewFolderDropdown from '../../Folder/Components/NewFolderDropdown';
import TableMoveButton from '../../Folder/Components/TableMoveButton';
import TableDuplicateButton from '../../Folder/Components/TableDuplicateButton';
import TableDeleteButton from '../../Folder/Components/TableDeleteButton';
import DeleteTableItemModal from '../../Folder/DeleteTableItemModal';
import EditTableItemModal from '../../Folder/EditTableItemModal';
import { calculateTablePage } from '../../../slices/folder/helper';

function FeedLibrary() {
  const dispatch = useDispatch();
  const location = useLocation();
  const params = useParams();
  const searchParams = new URLSearchParams(location.search);
  const folderId = searchParams.get('folderId');

  const selectRoutePaths = createSelector((state) => state.MenuData, (state) => ({
    clientPath: state.clientPath,
    brandPath: state.brandPath,
    title: state.title,
  }));
  const { clientPath, brandPath, title } = useSelector(selectRoutePaths);

  const selectLocations = createSelector((state) => state.router.previousLocations, (state) => state);
  const previousLocations = useSelector(selectLocations)

  const selectItemsState = createSelector(state => state.Folder, state => state.selectedItems);
  const selectedItems = useSelector(selectItemsState);

  const selectFeedStates = createSelector((state) => state.Feed, (state) => ({
    feeds: state.feeds,
    feedsHasMore: state.feedsHasMore,
    feedsPage: state.feedsPage,
  }));
  const {feeds, feedsHasMore, feedsPage} = useSelector(selectFeedStates);

  useEffect(() => {
    if (brandPath !== null) {
      dispatch(resetFeedState());
      if (location.search === "") {
        dispatch(setFolderPath(null));
      } else {
        dispatch(setFolderPath(location.search.split("=")[1]));
      }
      if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP")) {
        dispatch(setPreloader(true));
        dispatch(getFeeds()).then(res => {
          const updatedBreadcrumbTitle = [];
          if (title && title.length === 0) {
            let feedsPath = `/${params.client}/${params.brand}`;
            if (params.market) {
              feedsPath += `/${params.market}`;
            }
            feedsPath += '/feeds';
            updatedBreadcrumbTitle.push({ name: 'Feeds', src: feedsPath });
          } else if (title && title.length > 1) {
            updatedBreadcrumbTitle.push(...title);
          }
          dispatch(replace(location.pathname, {
            feeds: res.payload,
            hasMore: true,
            firstLoad: false,
            title: updatedBreadcrumbTitle,
            feedsPage: calculateTablePage(res.payload.length),
          }));
          dispatch(setPreloader(false));
        })
      } else if (previousLocations[0].location.state !== null) {
        if (previousLocations[0].action === 'POP') {
          dispatch(setFeedsFirstLoad(false));
        } else {
          dispatch(setFeedsFirstLoad(previousLocations[0].location.state.firstLoad));
        }
        dispatch(getFeedSuccess(previousLocations[0].location.state.feeds));
        dispatch(setFeedsHasMore(previousLocations[0].location.state.hasMore));
        dispatch(setFeedsPage((previousLocations[0].location.state.feedsPage ?
          previousLocations[0].location.state.feedsPage :
          calculateTablePage(previousLocations[0].location.state.feeds?.length)
        )));
        dispatch(setBreadcrumb({ pageTitle: 'Feeds', title: previousLocations[0].location.state.title }));
        if (previousLocations[0].location.state.isLoading) {
          dispatch(setFeedsLoading(previousLocations[0].location.state.isLoading));
        }
        if (previousLocations[0].location.state.showLoader) {
          dispatch(setFeedsShowLoader(previousLocations[0].location.state.showLoader));
        }
      }
    }
  }, [clientPath, brandPath, location.search]);

 

  async function openFeedFolder() {
    dispatch(setFolderHistory([{ name: "Feed Library" }]))
    dispatch(setFolderRootPath("feed"));
    await dispatch(getFolderRootThunk());
    dispatch(toggleFolderModal());
  }

  async function newFolderFunction(data) {
    const folderObj = await dispatch(newFolder({ ...data, type: "feed" }))
    if (folderObj) {
      const updatedFeeds = [folderObj, ...feeds];
      dispatch(getFeedSuccess(updatedFeeds));
      dispatch(setFeedsFirstLoad(false));
      dispatch(replace(window.location.href, {
        title: title,
        feeds: updatedFeeds,
        hasMore: feedsHasMore,
        firstLoad: false,
        feedsPage: feedsPage
      }));
    }
  }

  let typingTimer;
  let doneTypingInterval = 500;
  async function handleSearch(e) {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(async () => {
      dispatch(getFeedSuccess(null));
      dispatch(setFeedsLoading(false));
      dispatch(setFeedsHasMore(true));
      dispatch(setFeedsFirstLoad(false));
      dispatch(setFeedsPage(1));
      if (e.target.value === "" || e.target.value === " ") {
        dispatch(setQuery(null));
      } else {
        dispatch(setQuery(e.target.value));
      }
      const res = await dispatch(getFeeds())
      dispatch(getFeedSuccess(res.payload));
    }, doneTypingInterval);
  }

  // if (checkPermission("brands", brandPath, "feedView")) {
  return (
    <Card>
      <CardBody>
        <div className='table-responsive table-card'>
          <Container className='mt-2 d-flex flex-wrap align-items-center justify-content-end gap-1' fluid>
            {checkPermission("brands", brandPath, "feedCreate") ?
              <Button color='success' onClick={() => {
                dispatch(setFeedModalType("feed"));
                dispatch(toggleCreateFeedModal());
              }}>
                <i className='ri-add-fill align-bottom'></i>
                Create Feed
              </Button>
              : null}
            <NewFolderDropdown newFolderFunction={newFolderFunction} />
          </Container>
          <Container className='mt-2 d-flex align-items-center justify-content-between gap-1' fluid>
            <div>
              {selectedItems.length > 0 ?
                <div className="d-flex align-items-center gap-1">
                  <TableMoveButton onClick={openFeedFolder} allowedPermission={"feedEdit"} />
                  <TableDuplicateButton onClick={() => dispatch(toggleDuplicateAllModal())} allowedPermission={"feedCreate"} />
                  <TableDeleteButton onClick={() => dispatch(toggleDeleteAllModal())} allowedPermission={"feedDelete"} />
                </div>
                : null}
            </div>
            <div className="d-flex align-items-center gap-1">
              <div className="form-icon">
                <Input type="text" className="form-control form-control-icon" placeholder="Search Ads" onKeyUp={handleSearch} />
                <i className="ri-search-line search-icon text-muted"></i>
              </div>
            </div>
          </Container>
          <FeedLibraryTable />
          <DeleteTableItemModal />
          <EditTableItemModal />
          <FolderModal />
          <DuplicateAllModal />
          <DeleteAllModal />
        </div>
      </CardBody >
    </Card >
  )
  // } else {
  //   return <Navigate to={"/out-of-permission"} />
  // }

}

export default FeedLibrary